import { get_token, set_drive_id } from '@/router/index.js';
import $ from 'jquery';

export const navbar_profile_drive_methods = {
  build_drive_url() {
    return new URL('/aic_one_api/aic_drive/get_drive/', process.env.VUE_APP_API_BASE_URL).toString();
  },

  get_drive_id() {
    const token = get_token();
    if (!this.ensure_profile_token(token)) return;

    return this.request_drive_id(token, localStorage.getItem('user_id'));
  },

  request_drive_id(token, user_id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.build_drive_url(),
        method: 'GET',
        data: { user_id },
        headers: {
          'Authorization': `Token ${token}`,
        },
        success: response => this.handle_drive_success(response, resolve),
        error: (xhr, error) => this.handle_drive_error(xhr, error, reject),
      });
    });
  },

  handle_drive_success(response, resolve) {
    const response_data = typeof response === 'string' ? JSON.parse(response) : response;
    const drive_id = response_data.data?.drive_id;
    set_drive_id(drive_id);
    resolve(drive_id);
  },

  handle_drive_error(xhr, error, reject) {
    console.error('Error fetching drive', xhr.responseText || error);
    reject(error);
  },
};
